module.exports = __webpack_public_path__ + "media/newstyle/images/file-read-31987a54f07e95fd810af6bd2dd34d8a.png";